import React from 'react';
import { CTAButton } from './CTAButton';
export function MetricsSection() {
  return <section className="w-full bg-gradient-to-b from-gray-900 to-gray-800 py-16 md:py-24" data-id="element-294">
      <div className="max-w-6xl mx-auto px-6" data-id="element-295">
        {/* Title */}
        <div className="text-center mb-12" data-id="element-296">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white leading-tight mb-6 max-w-4xl mx-auto" data-id="element-297">
            Cuando sabes leer tus métricas, esa pantalla deja de dar miedo y se
            convierte en tu tablero de mando:
          </h2>
          <p className="text-xl md:text-2xl text-blue-300 font-semibold" data-id="element-298">
            sabes qué campaña vende, cuál apagar y dónde poner tu presupuesto.
          </p>
        </div>

        {/* Image */}
        <div className="mb-12" data-id="element-299">
          <img src="https://cdn.magicpatterns.com/uploads/tkFvfs543snZttWmZCferj/ChatGPT_Image_4_dic_2025,_12_56_39_p.m..png" alt="Dashboard de Meta Ads mostrando métricas y campañas" className="w-full h-auto rounded-2xl shadow-2xl" data-id="element-300" />
        </div>

        {/* CTA Button */}
        <div className="text-center" data-id="element-301">
          <a href="#pricing" className="inline-block" data-id="element-302">
            <CTAButton size="large" data-id="element-303">
              Quiero Aprender a Leer Mis Métricas →
            </CTAButton>
          </a>
        </div>
      </div>
    </section>;
}